/** @format */
import angular from 'angular';
import { commonUniversityServiceModule } from '../university/university.service';

export const codeBookServiceModule = 'sis-common.codeBook';

(function () {
    angular.module(codeBookServiceModule, [commonUniversityServiceModule]).factory('codeBookService', CodeBookService);

    /**
     * @ngInject
     */
    function CodeBookService(universityService, $http, $q, $log) {
        var LIST_CODE_BOOKS_CUSTOM_BASE_URL = '/kori/api/custom-codebooks';
        var CODE_BOOKS_BASE_URL = '/kori/api/codebooks';
        var COURSE_UNIT_SCOPE = 'urn:code:classification-scope:course-unit';
        var DEGREE_PROGRAMME_SCOPE = 'urn:code:classification-scope:degree-programme';
        var STUDY_MODULE_SCOPE = 'urn:code:classification-scope:study-module';

        return {
            getCustomCodeBooks: function (classificationScopeUrn) {
                var url =
                    LIST_CODE_BOOKS_CUSTOM_BASE_URL +
                    '/' +
                    classificationScopeUrn +
                    '?universityOrgId=' +
                    universityService.getCurrentUniversityOrgId();
                return $http
                    .get(url)
                    .then(function (response) {
                        const promises = [];
                        const codeBooks = [];
                        _.forEach(response.data, function (codeBookUrn) {
                            promises.push(
                                $http.get(CODE_BOOKS_BASE_URL + '/' + codeBookUrn).then(function (codeBookResult) {
                                    codeBooks.push(codeBookResult.data);
                                }),
                            );
                        });
                        return $q.all(promises).then(() => {
                            return _.sortBy(codeBooks, 'urn');
                        });
                    })
                    .catch(function (error) {
                        $log.error('Failed to get CustomCodeBooks from URL ', url, 'ERROR:', error);
                    });
            },
            getCourseUnitCustomCodeBooks: function () {
                return this.getCustomCodeBooks(COURSE_UNIT_SCOPE).catch(function (error) {
                    $log.error('Failed to get CourseUnitCustomCodeBooks from URL ', COURSE_UNIT_SCOPE, 'ERROR:', error);
                });
            },
            getDegreeProgrammeCustomCodeBooks: function () {
                return this.getCustomCodeBooks(DEGREE_PROGRAMME_SCOPE).catch(function (error) {
                    $log.error('Failed to get DegreeProgrammeCustomCodeBooks from URL ', DEGREE_PROGRAMME_SCOPE, 'ERROR:', error);
                });
            },
            getStudyModuleCustomCodeBooks: function () {
                return this.getCustomCodeBooks(STUDY_MODULE_SCOPE).catch(function (error) {
                    $log.error('Failed to get StudyModuleCustomCodeBooks from URL ', STUDY_MODULE_SCOPE, 'ERROR:', error);
                });
            },

            // getCustomCodeBookModel function can be used to create a js-data model like object, that can
            // be passed components like displayUrn and referredObjectSelectEditor that require a js-data model

            getCustomCodeBookModel: codeBook => {
                return (function () {
                    const values = codeBook.codes;
                    return {
                        idAttribute: 'urn',
                        get: urn => {
                            return _.find(values, { urn: urn });
                        },
                        filter: query => {
                            return _.filter(values, value => {
                                const path = _.chain(query)
                                    .get('where')
                                    .keys()
                                    .find(key => {
                                        return _.includes(key, 'name.');
                                    })
                                    .value();
                                const queryString = _.get(_.get(query.where, path), 'likei');
                                const str = _.get(value, path);
                                const trimmedQueryString = _.trim(queryString, '%');
                                return _.includes(_.toLower(str), _.toLower(trimmedQueryString));
                            });
                        },
                    };
                })();
            },
        };
    }

    CodeBookService.$inject = ['universityService', '$http', '$q', '$log'];
})();
